// extracted by mini-css-extract-plugin
module.exports = {"hidden":"applyStep_hidden__UXnDW","textEmphasis":"applyStep_textEmphasis__LVOd3","processResultArea":"applyStep_processResultArea__qxXUI"};